module.exports = __webpack_public_path__ + "static/media/mastercard.b0583ea3.svg";